import Tippy from "@tippyjs/react";
import axios from "axios";
import $ from "jquery";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { BiCreditCard, BiInfoCircle } from "react-icons/bi";
import { FaChevronDown, FaChevronUp, FaHistory } from "react-icons/fa";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { ConfigContext } from "../../App";
import Breadcrumb from "../../components/Breadcrumb";
import Header from "../../components/partials/Header";
import Sidebar from "../../components/partials/Sidebar";
import PayDtlCard from "../../components/PayDtlCard";
import TruncatedTextWithTooltip from "../../components/TruncatedTextWithTooltip";
import config, { config2 } from "../../config";
import printIcon from "../../images/icons/print.png";
import { millionComma, printPrinter, removeMillionComma } from "../../utils";
import "./style.css";
import {
  formatItemStatus,
  formatStatus,
  uomConversion,
  uomConversionUnit,
} from "./util";
import { Modal } from "react-bootstrap";
import ItemViews from "../Master/Item/view";
import {
  apiListBranch,
  apiListCustomer,
  apiListGodown,
  apiListItem,
} from "../../api/master";

const formatAuditSummaryText = (text, iMap = {}, gMap = {}, cMap = {}, bMap = {}) => {
  if (!text || typeof text !== "string") return text;

  let res = text;

  // Replace Item #123 with item name if found
  res = res.replace(/\bItem\s*#(\d+)\b/gi, (match, id) => {
    return iMap[id] ? `${iMap[id]} (#${id})` : match;
  });

  // Replace Godown #123 with godown name if found
  res = res.replace(/\bGodown\s*#(\d+)\b/gi, (match, id) => {
    return gMap[id] ? `${gMap[id]} (#${id})` : match;
  });

  // Replace Customer #123 with customer name if found
  res = res.replace(/\bCustomer\s*#(\d+)\b/gi, (match, id) => {
    return cMap[id] ? `${cMap[id]} (#${id})` : match;
  });

  // Replace Branch #123 with branch name if found
  res = res.replace(/\bBranch\s*#(\d+)\b/gi, (match, id) => {
    return bMap[id] ? `${bMap[id]} (#${id})` : match;
  });

  // 1. Format payment mode amounts: "Cash UGX: 300000 -> 67770" or "USD: 40000 -> 32000"
  res = res.replace(
    /([A-Za-z0-9\s]+?:\s*)(-?\d+(?:\.\d+)?)\s*(?:->|&rarr;)\s*(-?\d+(?:\.\d+)?)/g,
    (match, p1, p2, p3) => {
      return `${p1}${millionComma(p2)} -> ${millionComma(p3)}`;
    },
  );

  // 2. Format "Total amount changed from 435280.00 to 203050.00" or "Rate changed from 100 to 200"
  res = res.replace(
    /(\b(?:amount|total|rate|price|discount|tax|round\s*off|gross|subtotal|balance|amt)\b[^\d]*?\bfrom\s+)(-?\d+(?:\.\d+)?\b)(\s+to\s+)(-?\d+(?:\.\d+)?\b)/gi,
    (match, p1, p2, p3, p4) => {
      return `${p1}${millionComma(p2)}${p3}${millionComma(p4)}`;
    },
  );

  // 3. Fallback for "from <number.decimals> to <number.decimals>"
  res = res.replace(
    /(\bfrom\s+)(-?\d+\.\d{2,4}\b)(\s+to\s+)(-?\d+\.\d{2,4}\b)/gi,
    (match, p1, p2, p3, p4) => {
      return `${p1}${millionComma(p2)}${p3}${millionComma(p4)}`;
    },
  );

  // 4. Format "Total amount updated to 203050.00" or similar
  res = res.replace(
    /(\b(?:amount|total|rate|price|discount|tax|round\s*off|gross|subtotal|balance|amt)\b[^\d]*?\b(?:to|is)\s+)(-?\d+(?:\.\d+)?\b)(?!\s*-\s*\d)/gi,
    (match, p1, p2) => {
      return `${p1}${millionComma(p2)}`;
    },
  );

  return res;
};

const formatHeaderChangeValue = (key, val, iMap = {}, gMap = {}, cMap = {}, bMap = {}) => {
  if (val === null || val === undefined || val === "") return "-";
  const isAmountField =
    /amount|total|rate|price|discount|tax|round_off|sub_total|balance|amt|gross/i.test(
      key,
    );
  if (isAmountField && !isNaN(Number(val))) {
    return millionComma(val);
  }
  if (/cust_id|customer_id/i.test(key) && cMap[val]) {
    return `${cMap[val]} (#${val})`;
  }
  if (/branch_id/i.test(key) && bMap[val]) {
    return `${bMap[val]} (#${val})`;
  }
  if (/godown_id/i.test(key) && gMap[val]) {
    return `${gMap[val]} (#${val})`;
  }
  if (/payment_mode_id/i.test(key)) {
    const pMode = config?.paymentMode?.find((p) => p?.value == val);
    if (pMode) return pMode.label;
  }
  return String(val);
};

function SaleView(props) {
  const { id } = useParams();
  const location = useLocation();
  let filter = location.state?.currentFilter;
  let currentFilterState = location.state?.showFilter;
  let page = location.state?.currentPageNo;
  const isTemp = location.state?.is_temp || false;
  const [sale, setSale] = useState(location.state?.sale || []);
  const itemLevelNarration = useContext(ConfigContext)?.itemLevelNarration;
  const multiVoucher = useContext(ConfigContext)?.multiVoucher;
  const loginBranch = useContext(ConfigContext)?.loginBranch;
  const [showItemModal, setShowItemModal] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [showAuditModal, setShowAuditModal] = useState(false);
  const [auditLogs, setAuditLogs] = useState([]);
  const [auditLoading, setAuditLoading] = useState(false);
  const [expandedLogId, setExpandedLogId] = useState(null);

  const [itemMap, setItemMap] = useState({});
  const [godownMap, setGodownMap] = useState({});
  const [customerMap, setCustomerMap] = useState({});
  const [branchMap, setBranchMap] = useState({});

  const fetchMasterMaps = async () => {
    try {
      const [itemRes, godownRes, custRes, branchRes] = await Promise.allSettled([
        apiListItem({ paginate: 0 }),
        apiListGodown({ paginate: 0 }),
        apiListCustomer({ paginate: 0 }),
        apiListBranch({ paginate: 0 }),
      ]);

      if (itemRes.status === "fulfilled") {
        const items =
          itemRes.value?.data?.data?.list ||
          itemRes.value?.data?.list ||
          [];
        const iMap = {};
        items.forEach((it) => {
          if (it?.item_id) iMap[it.item_id] = it.item_name;
        });
        setItemMap(iMap);
      }
      if (godownRes.status === "fulfilled") {
        const godowns =
          godownRes.value?.data?.data?.list ||
          godownRes.value?.data?.list ||
          [];
        const gMap = {};
        godowns.forEach((gd) => {
          if (gd?.godown_id) gMap[gd.godown_id] = gd.godown_name;
        });
        setGodownMap(gMap);
      }
      if (custRes.status === "fulfilled") {
        const custs =
          custRes.value?.data?.data?.list ||
          custRes.value?.data?.list ||
          [];
        const cMap = {};
        custs.forEach((c) => {
          if (c?.cust_id) cMap[c.cust_id] = c.cust_name;
        });
        setCustomerMap(cMap);
      }
      if (branchRes.status === "fulfilled") {
        const branches =
          branchRes.value?.data?.data?.list ||
          branchRes.value?.data?.list ||
          [];
        const bMap = {};
        branches.forEach((b) => {
          if (b?.branch_id) bMap[b.branch_id] = b.branch_name;
        });
        setBranchMap(bMap);
      }
    } catch (e) {
      console.error("Error fetching master maps for audit log:", e);
    }
  };

  const resolveItemName = (item) => {
    if (!item) return "-";
    if (typeof item === "number" || typeof item === "string") {
      const str = String(item).trim();
      const match = str.match(/^item\s*#?(\d+)$/i) || str.match(/^#?(\d+)$/);
      if (match && itemMap[match[1]]) return itemMap[match[1]];
      if (itemMap[str]) return itemMap[str];
      return str;
    }
    if (item.item_id && itemMap[item.item_id]) {
      return itemMap[item.item_id];
    }
    if (item.item_name) {
      const match = String(item.item_name).trim().match(/^item\s*#?(\d+)$/i);
      if (match && itemMap[match[1]]) return itemMap[match[1]];
      return item.item_name;
    }
    if (item.item_id) {
      return itemMap[item.item_id] || `Item #${item.item_id}`;
    }
    return "-";
  };

  const resolveGodownName = (item) => {
    if (!item) return "-";
    if (typeof item === "number" || typeof item === "string") {
      const str = String(item).trim();
      const match = str.match(/^godown\s*#?(\d+)$/i) || str.match(/^#?(\d+)$/);
      if (match && godownMap[match[1]]) return godownMap[match[1]];
      if (godownMap[str]) return godownMap[str];
      return str;
    }
    if (item.godown_id && godownMap[item.godown_id]) {
      return godownMap[item.godown_id];
    }
    if (item.godown_name) {
      const match = String(item.godown_name).trim().match(/^godown\s*#?(\d+)$/i);
      if (match && godownMap[match[1]]) return godownMap[match[1]];
      return item.godown_name;
    }
    if (item.godown_id) {
      return godownMap[item.godown_id] || `Godown #${item.godown_id}`;
    }
    return "-";
  };

  const handleFetchAuditLog = async () => {
    setShowAuditModal(true);
    setAuditLoading(true);
    fetchMasterMaps();
    try {
      const challanId = id || sale?.challan_id;
      const token = JSON.parse(
        localStorage.getItem("inventory") || "{}",
      )?.token;
      const res = await axios.post(
        `${config2.apiUrl}/challan/listChallanLog`,
        { challan_id: challanId, list_type: 3 },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token ? `Bearer ${token}` : "",
          },
        },
      );
      const data =
        res?.data?.data?.list ||
        res?.data?.list ||
        res?.data?.data ||
        res?.data ||
        [];
      setAuditLogs(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Error fetching challan audit log:", err);
      setAuditLogs([]);
    } finally {
      setAuditLoading(false);
    }
  };

  const handleItemView = (data) => {
    setSelectedItemId(data);
    setShowItemModal(true);
  };
  const handleItemModalClose = () => {
    setShowItemModal(false);
    setSelectedItemId(null);
  };

  console.log("SaleView->location", location);
  const [user, setUser] = useState({});
  const [showPageLoader, setShowPageLoader] = useState(false);

  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      setUser(JSON.parse(localStorage.getItem("inventory")).userData);
    }
  }, []);

  const [godown, setGodown] = useState([]);
  useEffect(
    function () {
      setGodown(() => props.godown);
    },
    [props],
  );

  useEffect(
    function () {
      if (sale.length == 0) {
        const url = isTemp
          ? `${config.apiUrl}/challan/listTempChallan`
          : `${config.apiUrl}/challan/listChallan`;

        $.post(
          `${url}`,
          JSON.stringify({ challan_id: id, list_type: 3 }),
          function (res) {
            setSale(res?.data?.list?.[0] || []);
          },
        );
      }
    },
    [sale],
  );
  const itemDtl = {
    item_id: "",
    item_name: "",
    requested_qty: "",
    rate: "",
    amount: "",
    disc: "",
    disc_amt: "",
    godown_id: "",
    avail_qty: "",
    alt_conv: "",
    base_uom: "",
    alt_uom: "",
    uom: "",
    alt_qty: "",
    alt_price: "",
    alt_rate: "",
    base_rate: "",
  };

  const payDtl = [
    { mode: "Cash UGX", conv: 1, conv_amt: "", amt: "" },
    { mode: "USD", conv: 1, conv_amt: "", amt: "" },
    { mode: "Momo Pay", conv: 1, conv_amt: "", amt: "" },
    { mode: "Airtel Money", conv: 1, conv_amt: "", amt: "" },
  ];

  const initialState = {
    branch_id: "",
    inv_no: "",
    cust_id: "",
    challan_date: moment().format("YYYY-MM-DD"),
    payment_mode_id: 1,
    item_dtl: [itemDtl],
    narration: "",
    vehicle_no: "",
    pay_dtl: payDtl,
  };
  const [formInputs, setFormInputs] = useState(initialState);

  // useEffect(() => {
  //   let prod = sale?.item_dtl?.map((element) => {
  //     if (element.uom === element.alt_uom) {
  //       return {
  //         ...element,
  //         requested_qty: element.alt_qty,
  //         alt_qty: element.requested_qty,
  //         amount: element.requested_qty * element.rate,
  //         received_qty: element.alt_conv * element.received_qty,
  //       };
  //     } else {
  //       return {
  //         ...element,
  //         amount: element.requested_qty * element.rate,
  //         // received_qty: element.alt_conv * element.received_qty,
  //       };
  //     }
  //   });

  //   setFormInputs((prevState) => ({
  //     ...prevState,
  //     item_dtl: prod,
  //     pay_dtl: sale?.pay_dtl ? JSON.parse(sale.pay_dtl) : prevState.pay_dtl,
  //   }));
  // }, [sale]);

  useEffect(() => {
    if (!sale?.challan_id) return;

    const fetchChallanDtl = async () => {
      try {
        const url = isTemp
          ? `${config2.apiUrl}/challan/listTempChallanDtl`
          : `${config2.apiUrl}/challan/listChallanDtl`;

        const res = await $.post(
          `${url}`,
          JSON.stringify({
            challan_id: sale?.challan_id,
            paginate: 0,
            list_type: 3,
          }),
        );
        console.log("res?.datares?.data", res?.data);
        let prod = res?.data?.list?.map((element) => {
          if (element.uom === element.base_uom) {
            return {
              ...element,
              amount: element.requested_qty * element.rate,
            };
          } else {
            return {
              ...element,

              requested_qty: element.alt_qty,
              alt_qty: element.requested_qty,
              amount: element.alt_qty * element.alt_price,
              received_qty:
                element.alt_received_qty ??
                element.alt_conv * element.received_qty,
            };
          }
        });

        setFormInputs((prevState) => ({
          ...prevState,
          item_dtl: prod,
          pay_dtl: sale?.pay_dtl ? JSON.parse(sale.pay_dtl) : prevState.pay_dtl,
        }));
      } catch (error) {
        console.error("Error fetching challan details:", error);
      }
    };

    fetchChallanDtl();
  }, [sale?.challan_id]);

  const [showPayDtl, setShowPayDtl] = useState(false);
  const handlePayDtl = () => {
    setShowPayDtl((prevState) => !prevState);
  };
  const navigate = useNavigate();
  const changeStatus = async (e, data) => {
    e.preventDefault();
    console.log("datadatadata", data);

    // Display confirmation dialog
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to change the status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, change it!",
    });

    if (result.isConfirmed) {
      const payload = {
        challan_details_id: data.challan_details_id,
        is_active: 4,
        updatedAt: data.updatedAt,
        // updatedAt: moment().format("YYYY-MM-DD"), // 2025-02-10
        // updatedAt: moment().toISOString(), //2025-02-10T10:02:26.566Z
      };
      try {
        // API call
        let response = await axios.post(
          `${config.apiUrl}/challan/challanDtlUpdate`,
          payload,
          {
            headers: {
              Authorization:
                "Bearer " +
                JSON.parse(localStorage.getItem("inventory"))?.token,
            },
          },
        );

        Swal.fire("Changed!", response?.data?.data, "success").then(() => {
          if (isTemp) {
            navigate("/temp-challan");
          } else {
            navigate("/challan");
          }
        });
      } catch (error) {
        // Handle error
        Swal.fire("Error!", error?.response?.data?.data?.message, "error");
      }
    }
  };

  function getPaymentMode() {
    const paymentModes = formInputs.pay_dtl.filter(
      (pay) => pay.amt !== "" && pay.amt !== undefined && pay.amt > 0,
    );

    if (paymentModes.length === 0) {
      return "Cash UGX";
    } else if (paymentModes.length === 1) {
      return paymentModes[0].mode;
    } else {
      return "Multiple";
    }
  }
  const noPricePrint = useContext(ConfigContext).noPricePrint;
  const displayQty = useContext(ConfigContext)?.displayQty;

  const printOptions = config.challanPrintOptions.filter((opt) => {
    if (noPricePrint != 1 && opt.key.includes("no_price")) return false;
    return true;
  });
  return (
    <>
      <div className="d-flex min-vh-100" style={{ background: "#DAE5FF" }}>
        <div
          id="page-loader"
          style={{
            display: showPageLoader !== false ? "block" : "none",
            width: "100%",
            height: "100%",
            position: "fixed",
            background: "black",
            opacity: ".5",
            zIndex: "1000",
            textAlign: "center",
            color: "white",
            fontSize: "16px",
            fontWeight: "bold",
            paddingTop: "200px",
          }}
        >
          {showPageLoader}
        </div>
        <Sidebar />
        <div className="content m-1  p-2 position-relative pb-8">
          <Header />
          <div className="d-flex align-items-center">
            <Breadcrumb path={["Challan", "View Challan"]} />
            {!isTemp && (
              <div
                className={`ms-3 d-flex align-items-center gap-3 ${
                  user?.role_id == 8 || sale?.is_active == 5 ? "d-none" : ""
                }`}
              >
                <Tippy content="Print">
                  <div className="dropdown d-inline-block">
                    <div className="btn-group">
                      <button
                        type="button"
                        className="btn border-0 p-0"
                        onClick={() => {
                          const defaultType =
                            loginBranch?.default_print_type ||
                            "_price_with_comp_name";
                          const opt = printOptions.find(
                            (o) => o.key === defaultType,
                          );
                          printPrinter(
                            id,
                            defaultType,
                            setShowPageLoader,
                            opt?.compName
                              ? user?.comp_data?.[0]?.comp_name || ""
                              : "",
                          );
                        }}
                      >
                        <img
                          src={printIcon}
                          className="img-fluid"
                          alt=""
                          style={{ width: "18px" }}
                        />
                      </button>
                      <button
                        type="button"
                        className="btn dropdown-toggle dropdown-toggle-split border-0"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        style={{ color: "black" }}
                      >
                        <span className="visually-hidden">Toggle Dropdown</span>
                      </button>
                      <ul className="dropdown-menu">
                        {printOptions.map((opt, index) => (
                          <li key={index}>
                            <button
                              className="dropdown-item"
                              onClick={() =>
                                printPrinter(
                                  id,
                                  opt.key,
                                  setShowPageLoader,
                                  opt.compName
                                    ? user?.comp_data?.[0]?.comp_name || ""
                                    : "",
                                )
                              }
                            >
                              {opt.label}
                            </button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </Tippy>

                <Tippy content="Audit Log">
                  <button
                    type="button"
                    className="btn border-0 p-0 d-flex align-items-center justify-content-center"
                    style={{ background: "transparent", cursor: "pointer" }}
                    onClick={handleFetchAuditLog}
                  >
                    <FaHistory size={18} style={{ color: "#3B62E9" }} />
                  </button>
                </Tippy>
              </div>
            )}
          </div>

          <main className="bg-white rounded-2" id="saleAdd">
            <div className="container-fluid p-2 position-relative">
              <Link
                to={isTemp ? "/temp-challan" : "/challan"}
                className="position-absolute text-decoration-none small"
                style={{ top: "-1.5rem", right: "0" }}
                state={{
                  backToCurrent: page,
                  appliedFilter: filter,
                  filterDisplay: currentFilterState,
                  pageSize: location.state?.pageSize || 10,
                }}
              >
                Go Back to List
              </Link>
              <form className=" p-1 m-0" autoComplete="off">
                <div className="row mb-1 p-1">
                  <div className="col-md-3">
                    <label htmlFor="challan_no">Challan No</label>
                    <input
                      type="text"
                      className="form-control"
                      id="challan_no"
                      value={sale?.challan_no || ""}
                      disabled
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="cust_id">Customer Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="cust_id"
                      value={sale?.mst_cust?.customer_name || ""}
                      disabled
                    />
                  </div>

                  {multiVoucher == 1 ? (
                    <div className="col-md-3">
                      <label htmlFor="voucher_id">Voucher Type</label>
                      <select
                        className="form-select"
                        value={sale.voucher_id}
                        name="voucher_id"
                        disabled
                      >
                        <option value="" hidden>
                          Select...
                        </option>
                        {props?.voucherList &&
                          props?.voucherList.map((list) => (
                            <option
                              key={list.voucher_id}
                              value={list.voucher_id}
                            >
                              {`${list.voucher_name}${
                                list.voucher_series || list.current_value
                                  ? ` (${list.voucher_series || ""}${list.current_value ?? ""})`
                                  : ""
                              }${list.sales_ledger ? ` - ${list.sales_ledger}` : ""}`}
                            </option>
                          ))}
                      </select>
                    </div>
                  ) : null}
                  <div className="col-md-3">
                    <label htmlFor="challan_date">Challan Date</label>
                    <input
                      type="text"
                      className="form-control"
                      id="challan_date"
                      value={moment(sale.challan_date).format("DD-MM-YYYY")}
                      disabled
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="payment_mode_id">Payment Mode</label>
                    <input
                      type="text"
                      className="form-control"
                      id="payment_mode_id"
                      value={
                        config?.paymentMode?.find(
                          (p) => p?.value == sale?.payment_mode_id,
                        )?.label || "N/A"
                      }
                      disabled
                    />
                  </div>
                  {user.role_id != 3 && user.role_id != 4 && (
                    <div className="col-md-3">
                      <label htmlFor="branch_name">Branch Name</label>

                      <input
                        type="text"
                        className="form-control"
                        id="branch_name"
                        value={sale?.mst_branch?.branch_name}
                        disabled
                      />
                    </div>
                  )}
                  <div className="col-md-3">
                    <label htmlFor="is_active">Status</label>
                    <input
                      type="text"
                      className="form-control"
                      id="is_active"
                      value={formatStatus(sale)}
                      disabled
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="vehicle_no">Vehicle No</label>
                    <input
                      type="text"
                      className="form-control"
                      id="vehicle_no"
                      value={sale?.vehicle_no || ""}
                      disabled
                    />
                  </div>
                  {sale.payment_mode_id == "2" && (
                    <div className="col-md-3">
                      <label htmlFor="is_zero_value">Zero Valued</label>
                      <select
                        name="is_zero_value"
                        value={sale.is_zero_value ?? ""}
                        className="form-select"
                        disabled
                      >
                        <option value="">NA</option>
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </select>
                    </div>
                  )}
                  <div className="col-md-3">
                    <label htmlFor="is_active">Narration</label>
                    <textarea
                      type="text"
                      className="form-control"
                      id="is_active"
                      value={sale?.narration || ""}
                      disabled
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="created_by_name">Created By</label>
                    <input
                      type="text"
                      className="form-control"
                      id="created_by_name"
                      value={sale?.created_by_name || ""}
                      disabled
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="created_on">Created On</label>
                    <input
                      type="text"
                      className="form-control"
                      id="created_on"
                      value={
                        sale?.created_on
                          ? moment(sale.created_on).format("DD-MM-YYYY hh:mm A")
                          : ""
                      }
                      disabled
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 p-1">
                    <table
                      className="table mt-4 rounded"
                      cellPadding="0"
                      cellSpacing="0"
                    >
                      <thead>
                        <tr>
                          <th>Item Name</th>
                          <th>UOM</th>
                          <th>Reqd. Qty</th>
                          {!isTemp && <th>Supp. Qty</th>}
                          {!isTemp && <th>Last Recd. Date</th>}
                          {!isTemp && <th>Last Recd. By</th>}
                          <th>Rate</th>
                          <th>Amount</th>
                          <th>Godown</th>
                          <th>Status</th>
                          {!isTemp && <th>Action</th>}
                        </tr>
                      </thead>
                      <tbody>
                        {formInputs.item_dtl &&
                          formInputs.item_dtl.map((v, i) => (
                            <tr key={i}>
                              <td style={{ width: "370px" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    // justifyContent: "center",
                                    alignItems: "center",
                                    gap: "1px",
                                  }}
                                >
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={v?.mst_item?.item_name}
                                    disabled
                                  />
                                  {formInputs.item_dtl[i]?.item_id ? (
                                    <Tippy content="View Item">
                                      <div>
                                        {" "}
                                        <span
                                          className=""
                                          style={{ cursor: "pointer" }}
                                          onClick={() => handleItemView(v)}
                                        >
                                          <BiInfoCircle size={20} />
                                        </span>
                                      </div>
                                    </Tippy>
                                  ) : null}
                                </div>
                                {itemLevelNarration == 1 ? (
                                  <textarea
                                    type="text"
                                    className="form-control mt-1"
                                    name={"narration"}
                                    value={v?.narration}
                                    disabled
                                    maxLength={100}
                                  />
                                ) : null}
                              </td>
                              <td style={{ width: "100px" }}>
                                {v?.alt_uom != null && v?.alt_uom != "" && (
                                  <select
                                    id=""
                                    name="uom"
                                    value={v?.uom}
                                    disabled
                                    className="form-select"
                                    style={{ width: "100px" }}
                                  >
                                    {[v.base_uom, v.alt_uom].map((ele, ind) => (
                                      <option value={ele}>{ele}</option>
                                    ))}
                                  </select>
                                )}
                              </td>
                              <td style={{ width: "90px" }}>
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  value={parseFloat(
                                    v.requested_qty || 0,
                                  ).toFixed(2)}
                                  disabled
                                />
                                {v?.alt_uom != null && v?.alt_uom != "" && (
                                  <span
                                    className="text-right"
                                    style={{
                                      wordBreak: "break-all",
                                      fontSize: "10px",
                                    }}
                                  >
                                    <TruncatedTextWithTooltip
                                      text={uomConversionUnit(v)}
                                    />
                                  </span>
                                )}
                              </td>
                              {!isTemp && (
                                <td style={{ width: "90px" }}>
                                  <input
                                    type="text"
                                    className="form-control text-end"
                                    value={parseFloat(
                                      v.received_qty || 0,
                                    ).toFixed(2)}
                                    disabled
                                  />
                                </td>
                              )}
                              {!isTemp && (
                                <td>
                                  <span style={{ fontSize: "10px" }}>
                                    {v.updatedAt &&
                                    moment(v.updatedAt).isValid()
                                      ? moment(v.updatedAt).format(
                                          "DD-MM-YYYY hh:mm A",
                                        )
                                      : "-"}
                                  </span>
                                </td>
                              )}
                              {!isTemp && (
                                <td>
                                  <span style={{ fontSize: "10px" }}>
                                    {v.last_receive_by || "-"}
                                  </span>
                                </td>
                              )}
                              <td style={{ width: "110px", maxWidth: "110px" }}>
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  value={
                                    v?.uom == v?.alt_uom
                                      ? millionComma(v?.alt_price)
                                      : millionComma(v?.rate)
                                  }
                                  // value={parseFloat(v?.rate || 0).toFixed(2)}
                                  disabled
                                />
                                {/* {v?.alt_uom != null && v?.alt_uom != "" && (
                                  <span style={{ whiteSpace: "nowrap" }}>
                                    {`Per (`}
                                    <TruncatedTextWithTooltip text={v?.base_uom} />
                                    {`)`}
                                  </span>

                                )} */}
                                {v?.alt_uom != null &&
                                  v?.alt_uom !== "" &&
                                  (v?.uom == v?.alt_uom ? (
                                    <span
                                      style={{
                                        wordBreak: "break-all",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {`( ${v?.rate} Per `}
                                      <TruncatedTextWithTooltip
                                        text={uomConversion(v)}
                                      />
                                      {`)`}
                                    </span>
                                  ) : (
                                    <span
                                      style={{
                                        wordBreak: "break-all",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {`(${v?.alt_price} Per `}
                                      <TruncatedTextWithTooltip
                                        text={uomConversion(v)}
                                      />
                                      {`)`}
                                    </span>
                                  ))}
                              </td>
                              <td style={{ width: "130px", maxWidth: "130px" }}>
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  value={millionComma(
                                    v?.amount,
                                    // v?.requested_qty * v?.rate
                                  )}
                                  //   value={parseFloat(
                                  //     parseFloat(v?.requested_qty || 0) *
                                  //       parseFloat(v?.rate || 0)
                                  //   ).toFixed(2)}
                                  disabled
                                />
                              </td>
                              <td style={{ width: "110px" }}>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={
                                    godown?.find(
                                      (x) => x?.godown_id === v?.godown_id,
                                    )?.godown_name || "-"
                                  }
                                  disabled
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={formatItemStatus(v)}
                                  disabled
                                />
                              </td>
                              {!isTemp && (
                                <td>
                                  {user.role_id !== 2 && v?.is_active === 2 && (
                                    <button
                                      onClick={(e) => changeStatus(e, v)}
                                      style={{
                                        border: "1px solid blue",
                                        borderRadius: "5px",
                                        background: "blue",
                                        color: "white",
                                        fontSize: "10px",
                                      }}
                                    >
                                      Mark Issued
                                    </button>
                                  )}
                                  {/* {v?.is_active == 2 && (
                                  <button
                                    onClick={(e) => changeStatus(e, v)}
                                    style={{
                                      border: "1px solid blue",
                                      borderRadius: "5px",
                                      background: "blue",
                                      color: "white",
                                    }}
                                  >
                                    Mark Issued
                                  </button>
                                )} */}
                                </td>
                              )}
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </form>
            </div>
            <div className="container-fluid">
              <div className="row">
                <div className="col-12 position-absolute bottom-0 start-0 end-0">
                  <div
                    className="row rounded px-2 py-3"
                    style={{ background: "#F4F7FE" }}
                  >
                    <div className="col-md-3">
                      <label htmlFor="totalRef">Gross Total</label>
                      <input
                        type="text"
                        className="form-control text-end"
                        id="totalRef"
                        value={millionComma(sale?.total_amount)}
                        disabled
                      />
                    </div>

                    {/* Discount Temporary Discount Disable */}
                    {/*<div className="col">
                                            <label htmlFor="discRef">Discount Total</label>
                                            <input
                                                type="text"
                                                className="form-control text-end"
                                                id="discRef"
                                                value={parseFloat(sale?.discount_amount || 0).toFixed(2)}
                                                disabled
                                            />
                                        </div>
                                        <div className="col">
                                            <label htmlFor="finalRef">Final Total</label>
                                            <input
                                                type="text"
                                                className="form-control text-end"
                                                id="finalRef"
                                                value={parseFloat(parseFloat(sale?.total_amount || 0) - parseFloat(sale?.discount_amount || 0)).toFixed(2)}
                                                disabled
                                            />
                                        </div>*/}

                    <div className="col d-flex mt-auto justify-content-end gap-2">
                      <div
                        style={{
                          border: "1px solid gray",
                          height: "32px",
                          minWidth: "200px",
                          borderRadius: "5px",
                          display: "flex",
                          alignItems: "center",
                          padding: "10px",
                        }}
                      >
                        <b className="me-2"> {getPaymentMode()} </b> :{" "}
                        {millionComma(sale?.total_amount)}
                      </div>
                      <BiCreditCard
                        size={32}
                        className="text-primary mt-1"
                        role="button"
                        onClick={handlePayDtl}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>

      {showPayDtl && (
        <PayDtlCard
          cardMode="view"
          showPayDtl={showPayDtl}
          handlePayDtl={handlePayDtl}
          formInputs={formInputs}
          setFormInputs={setFormInputs}
          grossTotal={removeMillionComma(sale?.total_amount)}
        />
      )}

      <Modal
        show={showItemModal}
        onHide={handleItemModalClose}
        keyboard={false}
        backdrop="static"
        size="lg"
      >
        <ItemViews id={selectedItemId} hide={handleItemModalClose} />
      </Modal>

      {/* Challan Audit Log Modal */}
      <Modal
        show={showAuditModal}
        onHide={() => setShowAuditModal(false)}
        keyboard={false}
        backdrop="static"
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fs-5 d-flex align-items-center gap-2">
            <FaHistory className="text-primary" /> Challan Audit Log
            {sale?.challan_no && (
              <span className="badge bg-light text-dark border ms-2">
                #{sale?.challan_no}
              </span>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "75vh", overflowY: "auto" }}>
          {auditLoading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-2 text-muted">Loading audit logs...</p>
            </div>
          ) : auditLogs.length === 0 ? (
            <div className="text-center py-5 text-muted">
              <FaHistory size={40} className="mb-2 text-secondary opacity-50" />
              <p className="mb-0">
                No audit log records found for this challan.
              </p>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-bordered table-hover align-middle mb-0">
                <thead className="table-light">
                  <tr className="text-nowrap" style={{ fontSize: "13px" }}>
                    <th style={{ width: "40px" }} className="text-center">
                      #
                    </th>
                    <th>Date & Time</th>
                    <th>Action</th>
                    <th>User</th>
                    <th>Total Amount</th>
                    <th>Summary of Changes</th>
                    <th className="text-center" style={{ width: "120px" }}>
                      Details
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {auditLogs.map((log, index) => {
                    const logDate =
                      log.changes?.edited_at ||
                      log.changes?.created_at ||
                      log.updatedAt ||
                      log.createdAt ||
                      log.challan_date;
                    const logAction =
                      log.action ||
                      log.changes?.action ||
                      (log.is_edited ? "UPDATE" : "INSERT");
                    const logUser =
                      (logAction === "UPDATE"
                        ? log.editor?.user_name
                        : log.creator?.user_name) ||
                      log.editor?.user_name ||
                      log.creator?.user_name ||
                      log.changes?.editor_name ||
                      log.changes?.creator_name ||
                      "-";
                    const logUserMob =
                      (logAction === "UPDATE"
                        ? log.editor?.user_mob
                        : log.creator?.user_mob) ||
                      log.editor?.user_mob ||
                      log.creator?.user_mob;
                    const summaryList =
                      log.changes?.summary &&
                      Array.isArray(log.changes.summary) &&
                      log.changes.summary.length > 0
                        ? log.changes.summary
                        : null;
                    const summaryText =
                      log.changes?.summary_text || log.narration || "-";
                    const isExpanded = expandedLogId === log.id;

                    return (
                      <React.Fragment key={log.id || log.log_id || index}>
                        <tr style={{ fontSize: "13px" }}>
                          <td className="text-center fw-bold text-muted">
                            {index + 1}
                          </td>
                          <td className="text-nowrap">
                            {logDate
                              ? moment(logDate).format("DD-MM-YYYY hh:mm A")
                              : "-"}
                          </td>
                          <td>
                            {logAction === "INSERT" || logAction === "CREATE" || logAction === "ADD" ? (
                              <span
                                className="badge px-2 py-1 text-white"
                                style={{ backgroundColor: "#10b981", fontSize: "11px", fontWeight: "600" }}
                              >
                                ADD
                              </span>
                            ) : logAction === "UPDATE" || logAction === "EDIT" ? (
                              <span
                                className="badge px-2 py-1 text-white"
                                style={{ backgroundColor: "#f59e0b", fontSize: "11px", fontWeight: "600" }}
                              >
                                EDIT
                              </span>
                            ) : (
                              <span
                                className="badge px-2 py-1 text-white"
                                style={{ backgroundColor: "#3b82f6", fontSize: "11px", fontWeight: "600" }}
                              >
                                {logAction}
                              </span>
                            )}
                          </td>
                          <td>
                            <div className="fw-semibold">{logUser}</div>
                            {logUserMob && (
                              <div
                                className="text-muted"
                                style={{ fontSize: "11px" }}
                              >
                                {logUserMob}
                              </div>
                            )}
                          </td>
                          <td className="text-nowrap fw-semibold">
                            {millionComma(log.total_amount)}
                          </td>
                          <td>
                            {summaryList ? (
                              <ul
                                className="mb-0 ps-3 text-start small"
                                style={{ listStyleType: "disc" }}
                              >
                                {summaryList.map((s, idx) => (
                                  <li key={idx} className="mb-1">
                                    {formatAuditSummaryText(
                                      s,
                                      itemMap,
                                      godownMap,
                                      customerMap,
                                      branchMap,
                                    )}
                                  </li>
                                ))}
                              </ul>
                            ) : (
                              <span className="small">
                                {formatAuditSummaryText(
                                  summaryText,
                                  itemMap,
                                  godownMap,
                                  customerMap,
                                  branchMap,
                                )}
                              </span>
                            )}
                          </td>
                          <td className="text-center">
                            <button
                              type="button"
                              className="btn btn-sm d-inline-flex align-items-center gap-1 px-2 py-1 shadow-sm"
                              style={{
                                fontSize: "12px",
                                fontWeight: "500",
                                backgroundColor: isExpanded ? "#1e293b" : "#3b82f6",
                                color: "#ffffff",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                setExpandedLogId(
                                  isExpanded ? null : log.id,
                                )
                              }
                            >
                              {isExpanded ? (
                                <>
                                  <FaChevronUp size={10} /> Hide
                                </>
                              ) : (
                                <>
                                  <FaChevronDown size={10} /> Details
                                </>
                              )}
                            </button>
                          </td>
                        </tr>

                        {/* Expandable detailed changes panel */}
                        {isExpanded && (
                          <tr className="bg-light">
                            <td colSpan={7} className="p-3">
                              <div className="card border shadow-sm p-3 bg-white rounded">
                                {/* Header Changes */}
                                {log.changes?.header_changes &&
                                  Object.keys(log.changes.header_changes)
                                    .length > 0 && (
                                    <div className="mb-3">
                                      <h6
                                        className="fw-bold text-secondary mb-2"
                                        style={{ fontSize: "12px" }}
                                      >
                                        Header Changes:
                                      </h6>
                                      <div className="d-flex flex-wrap gap-2">
                                        {Object.entries(
                                          log.changes.header_changes,
                                        ).map(([key, val]) => {
                                          const oldVal =
                                            val?.old !== undefined
                                              ? val.old
                                              : val?.old_id;
                                          const newVal =
                                            val?.new !== undefined
                                              ? val.new
                                              : val?.new_id;

                                          return (
                                            <div
                                              key={key}
                                              className="badge bg-light text-dark border p-2 text-start"
                                            >
                                              <span className="text-muted text-capitalize">
                                                {key.replace(/_/g, " ")}:{" "}
                                              </span>
                                              <span className="text-danger text-decoration-line-through me-1">
                                                {formatHeaderChangeValue(
                                                  key,
                                                  oldVal,
                                                  itemMap,
                                                  godownMap,
                                                  customerMap,
                                                  branchMap,
                                                )}
                                              </span>
                                              <span className="text-muted">
                                                &rarr;
                                              </span>
                                              <span className="text-success fw-bold ms-1">
                                                {formatHeaderChangeValue(
                                                  key,
                                                  newVal,
                                                  itemMap,
                                                  godownMap,
                                                  customerMap,
                                                  branchMap,
                                                )}
                                              </span>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  )}

                                {/* Payment Breakup Changes */}
                                {log.changes?.pay_dtl_changes &&
                                  log.changes.pay_dtl_changes.length > 0 && (
                                    <div className="mb-3">
                                      <h6
                                        className="fw-bold text-secondary mb-2"
                                        style={{ fontSize: "12px" }}
                                      >
                                        Payment Breakup Changes:
                                      </h6>
                                      <div className="table-responsive">
                                        <table className="table table-sm table-bordered mb-0">
                                          <thead className="table-light">
                                            <tr style={{ fontSize: "12px" }}>
                                              <th>Mode</th>
                                              <th>Old Amount</th>
                                              <th>New Amount</th>
                                              <th>Difference</th>
                                            </tr>
                                          </thead>
                                          <tbody style={{ fontSize: "12px" }}>
                                            {log.changes.pay_dtl_changes.map(
                                              (pay, pIdx) => (
                                                <tr key={pIdx}>
                                                  <td className="fw-semibold">
                                                    {pay.mode}
                                                  </td>
                                                  <td>
                                                    {millionComma(pay.old_amt)}
                                                  </td>
                                                  <td>
                                                    {millionComma(pay.new_amt)}
                                                  </td>
                                                  <td
                                                    className={
                                                      pay.diff > 0
                                                        ? "text-success fw-bold"
                                                        : pay.diff < 0
                                                        ? "text-danger fw-bold"
                                                        : ""
                                                    }
                                                  >
                                                    {pay.diff > 0
                                                      ? `+${millionComma(
                                                          pay.diff,
                                                        )}`
                                                      : millionComma(pay.diff)}
                                                  </td>
                                                </tr>
                                              ),
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  )}

                                {/* Items Added */}
                                {log.changes?.items_added &&
                                  log.changes.items_added.length > 0 && (
                                    <div className="mb-3">
                                      <h6
                                        className="fw-bold text-success mb-2"
                                        style={{ fontSize: "12px" }}
                                      >
                                        + Items Added (
                                        {log.changes.items_added.length}):
                                      </h6>
                                      <div className="table-responsive">
                                        <table className="table table-sm table-bordered table-success table-striped mb-0">
                                          <thead style={{ fontSize: "12px" }}>
                                            <tr>
                                              <th>Item Name</th>
                                              <th>Godown</th>
                                              <th>Qty</th>
                                              <th>Rate</th>
                                              <th>Alt Qty / Price</th>
                                            </tr>
                                          </thead>
                                          <tbody style={{ fontSize: "12px" }}>
                                            {log.changes.items_added.map(
                                              (item, itemIdx) => (
                                                <tr key={itemIdx}>
                                                  <td className="fw-semibold">
                                                    {resolveItemName(item)}
                                                  </td>
                                                  <td>
                                                    {resolveGodownName(item)}
                                                  </td>
                                                  <td>
                                                    {item.requested_qty}{" "}
                                                    {item.uom}
                                                  </td>
                                                  <td>
                                                    {millionComma(item.rate)}
                                                  </td>
                                                  <td>
                                                    {item.alt_qty
                                                      ? `${item.alt_qty} @ ${millionComma(
                                                          item.alt_price,
                                                        )}`
                                                      : "-"}
                                                  </td>
                                                </tr>
                                              ),
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  )}

                                {/* Items Removed */}
                                {log.changes?.items_removed &&
                                  log.changes.items_removed.length > 0 && (
                                    <div className="mb-3">
                                      <h6
                                        className="fw-bold text-danger mb-2"
                                        style={{ fontSize: "12px" }}
                                      >
                                        - Items Removed (
                                        {log.changes.items_removed.length}):
                                      </h6>
                                      <div className="table-responsive">
                                        <table className="table table-sm table-bordered table-danger table-striped mb-0">
                                          <thead style={{ fontSize: "12px" }}>
                                            <tr>
                                              <th>Item Name</th>
                                              <th>Godown</th>
                                              <th>Qty</th>
                                              <th>Rate</th>
                                            </tr>
                                          </thead>
                                          <tbody style={{ fontSize: "12px" }}>
                                            {log.changes.items_removed.map(
                                              (item, itemIdx) => (
                                                <tr key={itemIdx}>
                                                  <td className="fw-semibold">
                                                    {resolveItemName(item)}
                                                  </td>
                                                  <td>
                                                    {resolveGodownName(item)}
                                                  </td>
                                                  <td>
                                                    {item.requested_qty}{" "}
                                                    {item.uom}
                                                  </td>
                                                  <td>
                                                    {millionComma(item.rate)}
                                                  </td>
                                                </tr>
                                              ),
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  )}

                                {/* Items Modified */}
                                {log.changes?.items_modified &&
                                  log.changes.items_modified.length > 0 && (
                                    <div className="mb-3">
                                      <h6
                                        className="fw-bold text-warning mb-2"
                                        style={{ fontSize: "12px" }}
                                      >
                                        ~ Items Modified (
                                        {log.changes.items_modified.length}):
                                      </h6>
                                      <div className="table-responsive">
                                        <table className="table table-sm table-bordered mb-0">
                                          <thead
                                            className="table-light"
                                            style={{ fontSize: "12px" }}
                                          >
                                            <tr>
                                              <th>Item Name</th>
                                              <th>Changes</th>
                                            </tr>
                                          </thead>
                                          <tbody style={{ fontSize: "12px" }}>
                                            {log.changes.items_modified.map(
                                              (item, itemIdx) => {
                                                const itemChanges =
                                                  item.changes || item;
                                                const isObj =
                                                  typeof itemChanges ===
                                                    "object" &&
                                                  itemChanges !== null &&
                                                  !Array.isArray(itemChanges);

                                                return (
                                                  <tr key={itemIdx}>
                                                    <td className="fw-semibold">
                                                      {resolveItemName(item)}
                                                    </td>
                                                    <td>
                                                      {isObj ? (
                                                        <div className="d-flex flex-wrap gap-2">
                                                          {Object.entries(
                                                            itemChanges,
                                                          ).map(
                                                            ([fKey, fVal]) => {
                                                              if (
                                                                fKey ===
                                                                  "item_name" ||
                                                                fKey ===
                                                                  "item_id"
                                                              )
                                                                return null;
                                                              const isAmt =
                                                                /amount|total|rate|price|discount|tax|amt/i.test(
                                                                  fKey,
                                                                );
                                                              const oldV =
                                                                fVal &&
                                                                typeof fVal ===
                                                                  "object"
                                                                  ? fVal.old !==
                                                                    undefined
                                                                    ? fVal.old
                                                                    : fVal.old_id
                                                                  : undefined;
                                                              const newV =
                                                                fVal &&
                                                                typeof fVal ===
                                                                  "object"
                                                                  ? fVal.new !==
                                                                    undefined
                                                                    ? fVal.new
                                                                    : fVal.new_id
                                                                  : fVal;

                                                              const fmtOld =
                                                                fKey === "godown_id"
                                                                  ? resolveGodownName(oldV)
                                                                  : isAmt &&
                                                                    !isNaN(
                                                                      Number(oldV),
                                                                    )
                                                                  ? millionComma(
                                                                      oldV,
                                                                    )
                                                                  : oldV;
                                                              const fmtNew =
                                                                fKey === "godown_id"
                                                                  ? resolveGodownName(newV)
                                                                  : isAmt &&
                                                                    !isNaN(
                                                                      Number(newV),
                                                                    )
                                                                  ? millionComma(
                                                                      newV,
                                                                    )
                                                                  : newV;

                                                              return (
                                                                <div
                                                                  key={fKey}
                                                                  className="badge bg-light text-dark border p-2 text-start"
                                                                >
                                                                  <span className="text-muted text-capitalize">
                                                                    {fKey.replace(
                                                                      /_/g,
                                                                      " ",
                                                                    )}
                                                                    :{" "}
                                                                  </span>
                                                                  {oldV !==
                                                                    undefined && (
                                                                    <>
                                                                      <span className="text-danger text-decoration-line-through me-1">
                                                                        {String(
                                                                          fmtOld ??
                                                                            "-",
                                                                        )}
                                                                      </span>
                                                                      <span className="text-muted">
                                                                        &rarr;
                                                                      </span>
                                                                    </>
                                                                  )}
                                                                  <span className="text-success fw-bold ms-1">
                                                                    {String(
                                                                      fmtNew ??
                                                                        "-",
                                                                    )}
                                                                  </span>
                                                                </div>
                                                              );
                                                            },
                                                          )}
                                                        </div>
                                                      ) : (
                                                        <pre className="mb-0 small">
                                                          {JSON.stringify(
                                                            itemChanges,
                                                            null,
                                                            2,
                                                          )}
                                                        </pre>
                                                      )}
                                                    </td>
                                                  </tr>
                                                );
                                              },
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  )}

                                {/* Initial Creation Pay Breakdown (for INSERT) */}
                                {(log.action === "INSERT" ||
                                  log.changes?.action === "CREATE") &&
                                  log.pay_dtl &&
                                  Array.isArray(log.pay_dtl) && (
                                    <div className="mb-2">
                                      <h6
                                        className="fw-bold text-secondary mb-2"
                                        style={{ fontSize: "12px" }}
                                      >
                                        Initial Payment Breakdown:
                                      </h6>
                                      <div className="d-flex flex-wrap gap-2">
                                        {log.pay_dtl
                                          .filter((p) => Number(p.amt) > 0)
                                          .map((p, pIdx) => (
                                            <div
                                              key={pIdx}
                                              className="badge bg-light text-dark border p-2"
                                            >
                                              <span className="text-muted">
                                                {p.mode}:{" "}
                                              </span>
                                              <span className="fw-bold">
                                                {millionComma(p.amt)}
                                              </span>
                                            </div>
                                          ))}
                                      </div>
                                    </div>
                                  )}

                                {/* Extra Metadata Footer */}
                                <div className="d-flex flex-wrap gap-3 mt-2 pt-2 border-top small text-muted">
                                  {log.mst_cust?.customer_name && (
                                    <div>
                                      <strong>Customer:</strong>{" "}
                                      {log.mst_cust.customer_name}
                                    </div>
                                  )}
                                  {log.mst_branch?.branch_name && (
                                    <div>
                                      <strong>Branch:</strong>{" "}
                                      {log.mst_branch.branch_name}
                                    </div>
                                  )}
                                  {log.vehicle_no && (
                                    <div>
                                      <strong>Vehicle No:</strong>{" "}
                                      {log.vehicle_no}
                                    </div>
                                  )}
                                  {log.narration && (
                                    <div>
                                      <strong>Narration:</strong> {log.narration}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setShowAuditModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default SaleView;
